import { render, staticRenderFns } from "./CommentOnSharedTalentListItem.vue?vue&type=template&id=d08385d6&scoped=true&"
import script from "./CommentOnSharedTalentListItem.vue?vue&type=script&lang=ts&"
export * from "./CommentOnSharedTalentListItem.vue?vue&type=script&lang=ts&"
import style0 from "./CommentOnSharedTalentListItem.vue?vue&type=style&index=0&id=d08385d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08385d6",
  null
  
)

/* custom blocks */
import block0 from "./CommentOnSharedTalentListItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports